// import Errors from './errors';
// const {checkDocumentExists} = require('./errors');
class FirestoreCrudOperations {
  constructor(db, firestore) {
    this.db = db;
    this.firestore = firestore;
  }

  async saveObjectToFirestore(objectModel, objectToSave, updateOrCreate) {
    let objectId = objectToSave.id;
    const validatedObject = await objectModel.validate(objectToSave);
    const collectionRef = this.db.collection(objectModel.COLLECTION);

    if (updateOrCreate) {
      // then we use the docRef.set function, which doesn't care if the object exists already
      const docRef = objectId ? collectionRef.doc(objectId) : collectionRef.doc();
      objectId = docRef.id; // this ensures objectId will be set regardless of whether it was passed in
      // TODO: right now we only set updated timestamp, as we don't know if it is getting created anew

      this.setUpdatedTimestamp(validatedObject);
      await docRef.set(validatedObject);
    } else if (!objectId) {
      // then we need to generate a new key and create a new object in firestore
      this.setCreatedTimestamp(validatedObject);
      const docRef = collectionRef.doc();
      objectId = docRef.id;
      await docRef.set(validatedObject);
    } else {
      // an update to an existing firestore object
      this.setUpdatedTimestamp(validatedObject);
      await collectionRef.doc(objectId).update(validatedObject);
    }

    return objectId;
  }

  async writeObjectToFirestore(objectModel, objectToSave, merge = false) {
    const updatedAt = new Date();
    let objectId = objectToSave.id;
    const collectionRef = this.db.collection(objectModel.COLLECTION);
    const validatedObject = await objectModel.validate(objectToSave);
    validatedObject.createdAt = objectToSave.createdAt ? objectToSave.createdAt : updatedAt;
    validatedObject.updatedAt = updatedAt;

    if (objectId) {
      await collectionRef.doc(objectId).set(validatedObject, {
        merge
      });
    } else {
      const docRef = await collectionRef.add(validatedObject);
      objectId = docRef.id;
    }

    return {
      id: objectId,
      ...validatedObject
    };
  }

  async loadObjectFromFirestore(objectModel, objectId) {
    const docSnapshot = await this.db.collection(objectModel.COLLECTION).doc(objectId).get();
    if (!docSnapshot.exists) throw new Error("not found");
    return this.convertFromFirestoreDoc(docSnapshot);
  }

  removeObjectFromFirestore(objectModel, objectId) {
    return this.db.collection(objectModel.COLLECTION).doc(objectId).delete();
  }

  async runQuery(query) {
    const querySnapshot = await query.get();
    return querySnapshot.docs.map(this.convertFromFirestoreDoc);
  }

  setCreatedTimestamp(objectToCreate) {
    objectToCreate.createdAt = this.firestore.FieldValue.serverTimestamp();
    objectToCreate.updatedAt = this.firestore.FieldValue.serverTimestamp();
    return objectToCreate;
  }

  setUpdatedTimestamp(objectToUpdate) {
    objectToUpdate.updatedAt = this.firestore.FieldValue.serverTimestamp();
    return objectToUpdate;
  }

  convertFromFirestoreDoc(firestoreDocument) {
    let retVal = firestoreDocument.data() || {}; // Special case for GeoFirestore records

    if (retVal.d && retVal.g && retVal.l) {
      // then we assume we are doing a raw firestore query on a geofirestore structured document, so we pull
      // out the "data" to the top level. This is needed for when we search for deals WITHOUT specifying an
      // exact location to search by. See ecCrudOperations.searchDeals() and
      // https://github.com/geofirestore/geofirestore-js#data-structure
      retVal = retVal.d;
    }

    retVal.id = firestoreDocument.id; // convert timestamps

    if (retVal.createdAt && retVal.createdAt.toMillis) {
      retVal.createdAt = retVal.createdAt.toMillis();
    }

    if (retVal.updatedAt && retVal.updatedAt.toMillis) {
      retVal.updatedAt = retVal.updatedAt.toMillis();
    }

    return retVal;
  }

}

module.exports = FirestoreCrudOperations;